// extracted by mini-css-extract-plugin
export default {"service":"Service_service__8Xm7V"};